import { HttpClient, HttpContext } from '@angular/common/http'
import { APIEnvelope } from '../models/api'
import { firstValueFrom } from 'rxjs'
import { httpParams, withHttpParams, pagination, SortParams, sort } from './http-params'
import { GLOBAL_LOADING_SPINNER_ENABLED } from '../interceptors/loading-spinner-interceptor'

export const fetchUntilExhausted = async <T>(
  http: HttpClient,
  url: string,
  pageSize: number,
  pageNumber: number,
  order?: readonly SortParams[],
  lastRes?: APIEnvelope<T>,
): Promise<APIEnvelope<T>> => {
  const res = await firstValueFrom(
    http.get<APIEnvelope<T>>(url, {
      params: httpParams(
        withHttpParams(pagination, { pageNumber, pageSize }),
        withHttpParams(sort, order),
      ),
      context: new HttpContext()
        .set(GLOBAL_LOADING_SPINNER_ENABLED, false),
    }),
  )
  const acc = {
    results: [...(lastRes?.results ?? []), ...res.results],
    total: res.total,
  }
  return acc.results.length !== acc.total &&
    res.results.length === res.total && // primary key issue
    res.results.length === pageSize // primary key issue too
    ? fetchUntilExhausted(http, url, pageSize, pageNumber + 1, order, acc)
    : acc
}
